const OverviewActiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.794 1.3335H5.20732C2.78065 1.3335 1.33398 2.78016 1.33398 5.20683V10.7868C1.33398 13.2202 2.78065 14.6668 5.20732 14.6668H10.7873C13.214 14.6668 14.6607 13.2202 14.6607 10.7935V5.20683C14.6673 2.78016 13.2207 1.3335 10.794 1.3335ZM6.60732 10.7935C6.60732 11.2202 6.26065 11.5668 5.82732 11.5668C5.40065 11.5668 5.05398 11.2202 5.05398 10.7935V8.62016C5.05398 8.1935 5.40065 7.84683 5.82732 7.84683C6.26065 7.84683 6.60732 8.1935 6.60732 8.62016V10.7935ZM10.9473 10.7935C10.9473 11.2202 10.6007 11.5668 10.174 11.5668C9.74065 11.5668 9.39398 11.2202 9.39398 10.7935V5.20683C9.39398 4.78016 9.74065 4.4335 10.174 4.4335C10.6007 4.4335 10.9473 4.78016 10.9473 5.20683V10.7935Z"
        fill="#F6FCFF"
      />
    </svg>
  );
};

export default OverviewActiveIcon;
